// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CollaborationLink_collaboration-link__J6QDo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 6px;
  padding: 5px 12px;
  line-height: 1.4;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}
.CollaborationLink_collaboration-link__J6QDo .CollaborationLink_icon__1Ocss {
  flex-shrink: 0;
}
.CollaborationLink_collaboration-link__J6QDo .CollaborationLink_text__cxNBd {
  font-style: normal;
}
.CollaborationLink_collaboration-link__J6QDo .CollaborationLink_arrow__Z-zvi {
  flex-shrink: 0;
  transition: transform 0.2s ease-in-out;
}
.CollaborationLink_collaboration-link__J6QDo:hover .CollaborationLink_arrow__Z-zvi {
  transform: translate(1.5px, -1.5px);
}
.CollaborationLink_collaboration-link__J6QDo.CollaborationLink_variant-default__v2I3K {
  background-color: rgba(26, 86, 219, 0.08);
  color: #1a56db;
  border: 1px solid rgba(26, 86, 219, 0.22);
}
.CollaborationLink_collaboration-link__J6QDo.CollaborationLink_variant-default__v2I3K:hover {
  background-color: #1a56db;
  color: #ffffff;
  border-color: #1a56db;
  box-shadow: 0 2px 8px rgba(26, 86, 219, 0.25);
}
.CollaborationLink_collaboration-link__J6QDo.CollaborationLink_variant-light__O1dSP {
  background-color: rgba(255, 255, 255, 0.16);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.32);
  backdrop-filter: blur(4px);
}
.CollaborationLink_collaboration-link__J6QDo.CollaborationLink_variant-light__O1dSP:hover {
  background-color: #ffffff;
  color: #1a56db;
  border-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.CollaborationLink_collaboration-link__J6QDo.CollaborationLink_variant-outline__yGY\\+m {
  background-color: transparent;
  color: #4b5563;
  border: 1px solid #d1d5db;
}
.CollaborationLink_collaboration-link__J6QDo.CollaborationLink_variant-outline__yGY\\+m:hover {
  background-color: #f3f4f6;
  color: #111827;
  border-color: #9ca3af;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/CollaborationLink/CollaborationLink.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;AACF;AACE;EACE,cAAA;AACJ;AAEE;EACE,kBAAA;AAAJ;AAGE;EACE,cAAA;EACA,sCAAA;AADJ;AAKI;EACE,mCAAA;AAHN;AAQE;EACE,yCAAA;EACA,cAAA;EACA,yCAAA;AANJ;AAQI;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,6CAAA;AANN;AAWE;EACE,2CAAA;EACA,cAAA;EACA,2CAAA;EACA,0BAAA;AATJ;AAWI;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,yCAAA;AATN;AAcE;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AAZJ;AAcI;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;AAZN","sourcesContent":[".collaboration-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n  border-radius: 6px;\n  padding: 5px 12px;\n  line-height: 1.4;\n  white-space: nowrap;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n\n  .icon {\n    flex-shrink: 0;\n  }\n\n  .text {\n    font-style: normal;\n  }\n\n  .arrow {\n    flex-shrink: 0;\n    transition: transform 0.2s ease-in-out;\n  }\n\n  &:hover {\n    .arrow {\n      transform: translate(1.5px, -1.5px);\n    }\n  }\n\n  // Default variant: for light backgrounds (Institution & Unit detail pages)\n  &.variant-default {\n    background-color: rgba(26, 86, 219, 0.08);\n    color: #1a56db;\n    border: 1px solid rgba(26, 86, 219, 0.22);\n\n    &:hover {\n      background-color: #1a56db;\n      color: #ffffff;\n      border-color: #1a56db;\n      box-shadow: 0 2px 8px rgba(26, 86, 219, 0.25);\n    }\n  }\n\n  // Light variant: for blue/dark backgrounds (Faculty personal information card)\n  &.variant-light {\n    background-color: rgba(255, 255, 255, 0.16);\n    color: #ffffff;\n    border: 1px solid rgba(255, 255, 255, 0.32);\n    backdrop-filter: blur(4px);\n\n    &:hover {\n      background-color: #ffffff;\n      color: #1a56db;\n      border-color: #ffffff;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    }\n  }\n\n  // Outline variant: subtle bordered button\n  &.variant-outline {\n    background-color: transparent;\n    color: #4b5563;\n    border: 1px solid #d1d5db;\n\n    &:hover {\n      background-color: #f3f4f6;\n      color: #111827;\n      border-color: #9ca3af;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collaboration-link": `CollaborationLink_collaboration-link__J6QDo`,
	"icon": `CollaborationLink_icon__1Ocss`,
	"text": `CollaborationLink_text__cxNBd`,
	"arrow": `CollaborationLink_arrow__Z-zvi`,
	"variant-default": `CollaborationLink_variant-default__v2I3K`,
	"variant-light": `CollaborationLink_variant-light__O1dSP`,
	"variant-outline": `CollaborationLink_variant-outline__yGY+m`
};
export default ___CSS_LOADER_EXPORT___;
